// combos list
export const FETCHING_COMBOS_LIST = '@@toyota/FETCHING_COMBOS_LIST';
export const FETCHED_COMBOS_LIST = '@@toyota/FETCHED_COMBOS_LIST';
export const FETCHED_COMBOS_LIST_FAILED = '@@toyota/FETCHED_COMBOS_LIST_FAILED';
export const CLEAN_COMBOS_LIST = '@@toyota/CLEAN_COMBOS_LIST';
export const FETCHING_COMBO_ACCESSORIES_LIST = '@@toyota/FETCHING_COMBO_ACCESSORIES_LIST';
export const FETCHED_COMBO_ACCESSORIES_LIST = '@@toyota/FETCHED_COMBO_ACCESSORIES_LIST';
export const FETCHED_COMBO_ACCESSORIES_LIST_FAILED = '@@toyota/FETCHED_COMBO_ACCESSORIES_LIST_FAILED';
export const CLEAN_COMBO_ACCESSORIES_LIST = '@@toyota/CLEAN_COMBO_ACCESSORIES_LIST';
export const FETCHING_COMBO_DEALERS_LIST = '@@toyota/FETCHING_COMBO_ACCESSORIES_LIST';
export const FETCHED_COMBO_DEALERS_LIST = '@@toyota/FETCHED_COMBO_DEALERS_LIST';
export const FETCHED_COMBO_DEALERS_LIST_FAILED = '@@toyota/FETCHED_COMBO_DEALERS_LIST_FAILED';
export const CLEAN_COMBO_DEALERS_LIST = '@@toyota/CLEAN_COMBO_DEALERS_LIST';
export const UPDATING_COMBO_HEADER = '@@toyota/UPDATING_COMBO_HEADER';
export const UPDATED_COMBO_HEADER = '@@toyota/UPDATED_COMBO_HEADER';
export const UPDATED_COMBO_HEADER_FAILED = '@@toyota/UPDATED_COMBO_HEADER_FAILED';

// combos detail
export const FETCHING_COMBO_DETAIL = '@@toyota/FETCHING_COMBO_DETAIL';
export const FETCHED_COMBO_DETAIL = '@@toyota/FETCHED_COMBO_DETAIL';
export const FETCHED_COMBO_DETAIL_FAILED = '@@toyota/FETCHED_COMBO_DETAIL_FAILED';
export const FETCHING_ACCESSORIES_LIST = '@@toyota/FETCHING_ACCESSORIES_LIST';
export const FETCHED_ACCESSORIES_LIST = '@@toyota/FETCHED_ACCESSORIES_LIST';
export const FETCHED_ACCESSORIES_LIST_FAILED = '@@toyota/FETCHED_ACCESSORIES_LIST_FAILED';
export const CLEAN_ACCESSORIES_LIST = '@@toyota/CLEAN_ACCESSORIES_LIST';
export const FETCHING_VEHICLES_MODELS_LIST = '@@toyota/FETCHING_VEHICLES_MODELS_LIST';
export const FETCHED_VEHICLES_MODELS_LIST = '@@toyota/FETCHED_VEHICLES_MODELS_LIST';
export const FETCHED_VEHICLES_MODELS_LIST_FAILED = '@@toyota/FETCHED_VEHICLES_MODELS_LIST_FAILED';
export const CLEAN_VEHICLES_MODELS_LIST = '@@toyota/CLEAN_VEHICLES_MODELS_LIST';
export const FETCHING_DEALERS_LIST = '@@toyota/FETCHING_DEALERS_LIST';
export const FETCHED_DEALERS_LIST = '@@toyota/FETCHED_DEALERS_LIST';
export const FETCHED_DEALERS_LIST_FAILED = '@@toyota/FETCHED_DEALERS_LIST_FAILED';
export const UPDATING_COMBO = '@@toyota/UPDATING_COMBO';
export const UPDATED_COMBO = '@@toyota/UPDATED_COMBO';
export const UPDATED_COMBO_FAILED = '@@toyota/UPDATED_COMBO_FAILED';
export const ADDING_COMBO_TO_MODEL = '@@toyota/ADDING_COMBO_TO_MODEL';
export const ADDED_COMBO_TO_MODEL = '@@toyota/ADDED_COMBO_TO_MODEL';
export const ADDED_COMBO_TO_MODEL_FAILED = '@@toyota/ADDED_COMBO_TO_MODEL_FAILED';
export const DELETING_COMBO_TO_MODEL = '@@toyota/DELETING_COMBO_TO_MODEL';
export const DELETED_COMBO_TO_MODEL = '@@toyota/DELETED_COMBO_TO_MODEL';
export const DELETED_COMBO_TO_MODEL_FAILED = '@@toyota/DELETED_COMBO_TO_MODEL_FAILED';


// upload excel
export const UPLOADING_COMBO_HEADER = '@@toyota/UPLOADING_COMBO_HEADER';
export const UPLOADED_COMBO_HEADER = '@@toyota/UPLOADED_COMBO_HEADER';
export const UPLOADED_COMBO_HEADER_FAILED = '@@toyota/UPLOADED_COMBO_HEADER_FAILED';
